import { render, staticRenderFns } from "./marketingTool.vue?vue&type=template&id=a481c1bc&scoped=true&"
import script from "./marketingTool.vue?vue&type=script&lang=js&"
export * from "./marketingTool.vue?vue&type=script&lang=js&"
import style0 from "./marketingTool.vue?vue&type=style&index=0&id=a481c1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a481c1bc",
  null
  
)

export default component.exports